import { usage as usageActions, publicUsageReport as publicUsageReportActions } from "../../constants/actionTypes";

import { emptyList } from "../../constants/componentConstants";

const INITIAL_STATE = {
  usageSummarydata: {
    chartData: [],
  },
  usageSummaryError: "",
  summaryDataLoading: true,
  generateReportData: "",
  generateReportError: "",
  generateReportLoading: false,
  reportsList: { emptyList },
  reportListLoading: true,
  usersListSearching: false,
  usersList: [{ id: "all", key: "all", label: "All", tenant_name: "All" }],
  usageReportSku: {
    data: [],
    loading: false,
  },
  usageUserList: {
    data: [],
    loading: false,
  }
};

const usage = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case usageActions.USAGE_SUMMARY_SET_DATA:
      return {
        ...state,
        usageSummarydata: {
          ...action?.payload?.data,
          chartData: action?.payload?.data?.chart_labels?.map((item, index) => ({
            name: item,
            value: action?.payload?.data?.chart_values?.[index],
          })),
        },
        usersListSearching: false,
        usersList: action?.payload?.data?.all_tenants
          ? [
            { id: "all", key: "all", label: "All", tenant_name: "All" },
            ...action?.payload?.data?.tenants?.map((item) => ({
              ...item,
              label: item?.tenant_name,
              value: item?.id,
            })),
          ]
          : state?.usersList,
      };
    case usageActions.USAGE_SUMMARY_SET_ERROR:
      return {
        ...state,
        usageSummarydata: INITIAL_STATE.usageSummarydata,
        usageSummaryError: action?.payload?.response,
      };
    case usageActions.SET_SUMMARY_LOADING:
      return {
        ...state,
        summaryDataLoading: action?.payload,
      };
    case usageActions.USAGE_REPORT_GENERATE_SUCCESS:
      return {
        ...state,
        generateReportData: {
          ...action?.data,
        },
        generateReportError: "",
      };
    case usageActions.USAGE_REPORT_GENERATE_ERROR:
      return {
        ...state,
        generateReportData: "",
        generateReportError: { ...action?.payload },
      };
    case usageActions.SET_GENERATE_REPORT_LOADING:
      return {
        ...state,
        generateReportLoading: action?.payload,
      };
    case usageActions.REPORT_LIST_SET_DATA:
      return {
        ...state,
        reportsList: {
          ...action?.payload?.data,
        },
      };
    case usageActions.REPORT_LIST_SET_ERROR:
      return {
        ...state,
        reportsList: { emptyList },
      };
    case usageActions.SET_REPORT_LIST_LOADING:
      return {
        ...state,
        reportListLoading: action?.payload,
      };

    case usageActions.SET_WEBSOCKET_USAGE_LIST_DATA:
      let tempUsageList = state?.reportsList;
      tempUsageList?.results?.forEach((element) => {
        if (action?.payload && element?.id === action?.payload?.usage_report) {
          element.report_state = action?.payload?.usage_report_state;
        }
      });
      return {
        ...state,
        reportsList: tempUsageList,
      };

    // Usage Report Catalog Sku
    case usageActions.GET_REPORT_SKU_ACTION: {
      return {
        ...state,
        usageReportSku: {
          ...state?.usageReportSku,
          loading: true,
        },
      };
    }

    case usageActions.GET_REPORT_SKU_SUCCESS: {
      const newData = action.payload?.data?.labs || [];
      const existingData = state?.usageReportSku?.data || [];

      const combinedData = [
        ...existingData,
        ...newData.filter(
          (newItem) => !existingData.some((oldItem) => oldItem.sku_id === newItem.sku_id)
        ),
      ];
      return {
        ...state,
        usageReportSku: {
          ...state?.usageReportSku,
          data: combinedData || [],
          loading: false,
        },
      };
    }

    case usageActions.GET_REPORT_SKU_ERROR: {
      return {
        ...state,
        usageReportSku: {
          ...state?.usageReportSku,
          loading: false,
        },
      };
    }

    case usageActions.GET_REPORT_SKU_RESET: {
      return {
        ...state,
        usageReportSku: {
          ...state?.usageReportSku,
          data: [],
        },
      };
    }

    // Usage User List Reducer
    case usageActions.GET_USAGE_USER_LIST_ACTION: {
      return {
        ...state,
        usageUserList: {
          ...state?.usageUserList,
          loading: true,
        },
      };
    }

    case usageActions.GET_USAGE_USER_LIST_SUCCESS: {
      const newUserData = action.payload?.data?.results || [];
      const existingData = state?.usageUserList?.data || [];

      const combinedUserData = [
        ...existingData,
        ...newUserData.filter(
          (newItem) => !existingData.some((oldItem) => oldItem.id === newItem.id)
        ),
      ];

      return {
        ...state,
        usageUserList: {
          ...state?.usageUserList,
          data: combinedUserData || [],
          loading: false,
        },
      };
    }

    case usageActions.GET_USAGE_USER_LIST_ERROR: {
      return {
        ...state,
        usageUserList: {
          ...state?.usageUserList,
          loading: false,
        },
      };
    }

    case usageActions.GET_USAGE_USER_LIST_RESET: {
      return {
        ...state,
        usageUserList: {
          ...state?.usageUserList,
          data: [],
        },
      };
    }

    case publicUsageReportActions.PUBLIC_REPORT_LIST_SET_DATA:
      return {
        ...state,
        publicReportsList: {
          ...action?.payload?.data,
        },
      };
    case publicUsageReportActions.PUBLIC_REPORT_LIST_SET_ERROR:
      return {
        ...state,
        publicReportsList: { emptyList },
      };
    case publicUsageReportActions.SET_PUBLIC_REPORT_LIST_LOADING:
      return {
        ...state,
        publicReportListLoading: action?.payload,
      };
    case publicUsageReportActions.PUBLIC_USAGE_REPORT_GENERATE_SUCCESS:
      return {
        ...state,
        generatePublicReportData: {
          ...action?.data,
        },
        generatePublicReportError: "",
      };
    case publicUsageReportActions.PUBLIC_USAGE_REPORT_GENERATE_ERROR:
      return {
        ...state,
        generatePublicReportData: "",
        generatePublicReportError: { ...action?.payload },
      };
    case publicUsageReportActions.SET_PUBLIC_GENERATE_REPORT_LOADING:
      return {
        ...state,
        generatePublicReportLoading: action?.payload,
      };

    default:
      return state;
  }
};

export default usage;
